import React from 'react'
import { CloseIcon } from '../../../assets/icons/Svg'
import { useDispatch } from 'react-redux'
import { clearTypeOfAdditionalModal } from '../../../features/modal/modalSlice'

interface NewPINModalProps {
    newPIN: number
    setNewPIN: (value: number) => void
    setFetchPin: (value: boolean) => void
}

export default function NewPINModal({ newPIN, setNewPIN, setFetchPin }: NewPINModalProps) {
    
    const dispatch = useDispatch();

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[250px] mx-5 bg-white rounded-lg shadow px-5 flex'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                    New PIN
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={() => {
                                        dispatch(clearTypeOfAdditionalModal())
                                        setNewPIN(0)
                                        setFetchPin(false)
                                    }}
                                >
                                    <CloseIcon />
                                </button>
                            </div>
                        </div>
                        <div className='w-full flex text-center justify-center'>
                            <p className='py-6 font-semibold text-[20px]'>{newPIN}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
